var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"loading":_vm.loading,"outlined":"","rounded":"lg"}},[_c('div',{staticClass:"pa-4 pb-1"},[_c('h6',{staticClass:"mb-0"},[_vm._v("Entradas")]),_c('ApexCharts',{attrs:{"type":"area","height":"250","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }